import { Constants } from "../lib/const/constants";

function pemToArrayBuffer(pem) {
    const base64 = pem
        .replace('-----BEGIN PUBLIC KEY-----', '')
        .replace('-----END PUBLIC KEY-----', '')
        .replace(/\s/g, '');

    const binary = window.atob(base64);

    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }

    return bytes.buffer;
}


export async function importPublicKey(publicKeyPem) {

    const binaryDer = pemToArrayBuffer(publicKeyPem);

    return crypto.subtle.importKey(
        'spki',
        binaryDer,
        {
            name: 'RSA-OAEP',
            hash: 'SHA-256',
        },
        false,
        ['encrypt']
    );
}


export async function getPublicKey() {

    const response = await fetch(
        Constants.FXMASTER_BASE_URL+'api/v1/encryption/public-key'
    );

    if (!response.ok) {
        throw new Error(
            'Unable to get encryption public key'
        );
    }

    const result = await response.json();

    return result.public_key;
}


function arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);

    let binary = '';

    for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
}



export async function encryptPayload(payload) {

    // 1. Get Laravel RSA public key
    const publicKeyPem = await getPublicKey();

    // 2. Convert public key to CryptoKey
    const publicKey = await importPublicKey(
        publicKeyPem
    );

    // 3. Generate a NEW AES-256 key
    const aesKey = await crypto.subtle.generateKey(
        {
            name: 'AES-GCM',
            length: 256
        },
        true,
        ['encrypt', 'decrypt']
    );

    // 4. Generate random IV
    const iv = crypto.getRandomValues(
        new Uint8Array(12)
    );

    // 5. Convert payload to JSON
    const jsonPayload = JSON.stringify(payload);

    const encodedPayload =
        new TextEncoder().encode(jsonPayload);

    // 6. Encrypt payload using AES-256-GCM
    const encrypted = await crypto.subtle.encrypt(
        {
            name: 'AES-GCM',
            iv: iv
        },
        aesKey,
        encodedPayload
    );

    // 7. Export AES key
    const rawAesKey =
        await crypto.subtle.exportKey(
            'raw',
            aesKey
        );

    // 8. Encrypt AES key using RSA public key
    const encryptedAesKey =
        await crypto.subtle.encrypt(
            {
                name: 'RSA-OAEP'
            },
            publicKey,
            rawAesKey
        );

    // AES-GCM produces ciphertext + 16-byte tag
    const encryptedBytes =
        new Uint8Array(encrypted);

    const tagLength = 16;

    const ciphertext =
        encryptedBytes.slice(
            0,
            encryptedBytes.length - tagLength
        );

    const tag =
        encryptedBytes.slice(
            encryptedBytes.length - tagLength
        );

    // 9. Return encrypted package
    return {
        key: arrayBufferToBase64(
            encryptedAesKey
        ),

        iv: arrayBufferToBase64(
            iv.buffer
        ),

        data: arrayBufferToBase64(
            ciphertext.buffer
        ),

        tag: arrayBufferToBase64(
            tag.buffer
        )
    };
}